import * as React from "react"

import { cn } from "@/lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  name?: string; // Tornar explícito para destacar a importância
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, name, id, autoComplete, ...props }, ref) => {
    // Garantir que sempre temos um name ou id
    const textareaName = name || id || `textarea-${Math.random().toString(36).substring(2, 9)}`;
    // Definir autoComplete se não estiver definido
    const textareaAutoComplete = autoComplete || "off";
    
    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        name={textareaName}
        id={id || textareaName}
        autoComplete={textareaAutoComplete}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
